<template>
  <div class="formxieyi" v-if="formEntry">
    <!-- 参赛须知弹窗 -->
<!--      <div class="pagePopMask pFull" @click.self="closePop" ></div>-->
    <div class="pagePopMask pFull"></div>
    <div class="pagePop pCenter">
      <div class="w">
        <div class="tit fnt_32 relative">{{ globalDataArray.siteTemplateLanguage.join_notice }}</div>

        <div class="cont txtCont scrollable" ref="scrollDiv"  @scroll="handleScroll">
          <div v-if="curInfoArray.competitionTemplateAssociation" class="fnt_20 agreement">
            {{ globalDataArray.siteTemplateLanguage.important_notice }}
            <span>({{ globalDataArray.siteTemplateLanguage.updated_follow }})</span>
          </div>
          <div v-html="compiledMarkdown"></div>
        </div>

        <div class="btnBox fnt_18 btnBox2">
          <a-checkbox :disabled="true" v-if="disabled||!readed" />
          <a-checkbox :checked="checked" @change="onChange" v-else />
          <button class="btn btn1" :title="globalDataArray.siteTemplateLanguage.btn_has_read" :class="{disabled : counter > 0}" :disabled="counter > 0" @click="agreeFun('1')">{{ globalDataArray.siteTemplateLanguage.agree_require }}<span v-if="counter > 0">({{ counter }}s)</span></button>
          <div class="btn btn2" :title="globalDataArray.siteTemplateLanguage.cancel" @click="agreeFun('2')" v-if="!curInfoArray.competitionTemplateAssociation">{{ globalDataArray.siteTemplateLanguage.cancel }}</div>
        </div>
<!--        <div class="close" @click.self="closePop" v-if="!curInfoArray.competitionTemplateAssociation"></div>-->
        <div class="close" @click="closePop" v-if="!curInfoArray.competitionTemplateAssociation"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue'
import { getArticleDetail, getIndexInfo } from '@/api/api'
import { marked } from 'marked'
export default {
  name: 'FormEntry',
  props: {
    noticeContent: String,
    formEntry: {
      type: Boolean,
      default: false
    },
    curInfoArray: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      counter: 0,
      interval: null,

      checked: false,
      disabled: true,
      content: {},
      readed: false,
      theEnd: true
    }
  },
  watch: {
    formEntry: {
      immediate: true,
      handler(val) {
        if (val) {
          const that = this
          this.checked = false
          this.readed = false
          this.theEnd = true
          this.disabled = true
          this.counterFun()
          this.$nextTick(() => {
            const scrollDiv = this.$refs.scrollDiv
            // 检查scrollDiv是否存在
            if (scrollDiv && scrollDiv.scrollHeight <= scrollDiv.clientHeight) {
              this.readed = true
            }
          })
        } else {
          if (this.interval != null) {
            this.counter = 0
            clearInterval(this.interval)
          }
        }
      }
    }
  },
  computed: {
    compiledMarkdown() {
      if (!this.noticeContent) return ''

      // 配置marked选项，与 ArticleListPage 组件保持一致
      marked.setOptions({
        breaks: true,
        gfm: true,
        sanitize: false,
        async: false
      })

      try {
        // 使用 marked.parse() 方法，与 ArticleListPage 组件保持一致
        const result = marked.parse(this.noticeContent)
        return result
      } catch (error) {
        console.error('Markdown 渲染失败:', error)
        return this.noticeContent
      }
    }
  },
  methods: {
    onChange(e) {
      this.checked = e.target.checked
    },

    agreeFun(res) {
      // 自定义事件，把res传给父组件,发射事件
      if (res == 2) {
        this.$emit('itemclick', res) // itemclick  为事件名
        this.$emit('update:formEntry', false)
      } else {
        if (this.checked) {
          this.$emit('itemclick', res) // itemclick  为事件名
          this.$emit('update:formEntry', false)
        } else {
          message.error(this.globalDataArray.siteTemplateLanguage.agreeToTheEntryNotice)
        }
      }
    },

    closePop() {
      this.$emit('update:formEntry', false)
      if (this.interval != null) {
        this.counter = 0
        clearInterval(this.interval)
      }
    },

    counterFun() {
      const that = this
      if (!that.checked) {
        that.counter = 1
        that.interval = setInterval(() => {
          that.counter--
          if (that.counter <= 0) {
            this.disabled = !this.disabled
            clearInterval(that.interval)
          }
        }, 1000)
      }
    },

    handleScroll() {
      if (typeof document === 'object') {
        const container = document.querySelector('.scrollable')
        if (container) {
          const { scrollTop, scrollHeight, clientHeight } = container
          if (scrollTop + clientHeight >= scrollHeight - 50) {
            this.readed = true
            if (this.theEnd) {
              this.theEnd = false
              message.success(this.globalDataArray.siteTemplateLanguage.to_the_end)
            }
          }
        }
      }
    }

  }
}
</script>
<style lang="scss" scoped>
::v-deep .pagePop .cont.txtCont {
  max-height: 36em;
}
.agreement {
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid;
}
</style>
